import React, { useContext } from 'react'
import PropTypes, { string } from 'prop-types'
import { TextBox } from 'components/atoms'
import { TextContext } from 'hocs/TextContextProvider/TextContextProvider'

const QualityManagement = ({ complaintManagement, report, standards }) => {
  const textContext = useContext(TextContext)
  return (
    <>
      {complaintManagement && (
        <TextBox title={ '' }>
          <span
            dangerouslySetInnerHTML={{
              __html: complaintManagement,
            }}></span>
        </TextBox>
      )}

      {report && (
        <TextBox title={ textContext['qualityManagement.report.title'] }>
          {report}
        </TextBox>
      )}

      {standards && (
        <TextBox title={ textContext['qualityManagement.standards.title'] }>
          {standards.map((standard, index) => (
            <p key={ `${ standard }-${ index }` }>{standard}</p>
          ))}
        </TextBox>
      )}
    </>
  )
}

QualityManagement.propTypes = {
  complaintManagement: string,
  report: PropTypes.string,
  standards: PropTypes.arrayOf(PropTypes.string),
}

export default QualityManagement
